import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  ContainerDivs,
  FossilFuelCompaniesContent,
  GetStartedInput
} from '../../components'
import container from '../../helpers/container'

import Styles from './FossilFuelCompanies.css'

@CSSModules(Styles)
export default class FossilFuelCompanies extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'Fossil fuel companies'
    const url = config.domain + config.routes.fossilFuelCompanies
    //
    return (
      <div styleName='page' id='top'>
        {container.helmet(title, '', url)}
        <ContainerDivs>
          <FossilFuelCompaniesContent />
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
        </ContainerDivs>
        <GetStartedInput/>
      </div>
    )
  }
}
